import { Heading } from 'ui/components';
import styles from './ProductTabsItem.module.scss';
import classNames from 'classnames';
import React, { useCallback } from 'react';

export interface ProductTabsItemProps {
	id: string;
	heading?: string;
	isActive?: string;
	setIsActive?: (id: string) => void;
}

export const ProductTabsItem: React.FC<ProductTabsItemProps> = ({ id, heading, isActive, setIsActive }) => {
	const isActiveThis = isActive === id;

	const activate = useCallback(() => {
		setIsActive?.(id);
	}, [setIsActive, id]);

	return (
		<div
			className={classNames(styles.ProductTabsItem, isActiveThis && styles.isActive)}
			role="tab"
			tabIndex={isActiveThis ? 0 : -1}
			aria-selected={isActiveThis}
			aria-controls={`panel-${id}`}
			id={`tab-${id}`}
			onClick={activate}
		>
			<div className={styles.ProductTabsItem_header}>
				<Heading className={styles.ProductTabsItem_heading} headingLevel="h3">
					{heading}
				</Heading>
			</div>
			<div className={styles.ProductTabsItem_border} />
		</div>
	);
};
